import { initialProjectDirectory } from "../../../entities/initialProjectDirectory"
import { logOut } from "../../../shared/lib"

export const getSettingsMenuItems = (currentUser,i18n,navigate) =>{
    const itemsArr = []
    if(currentUser && (currentUser.roles.includes("ROLE_ADMIN") || currentUser.roles.includes("ROLE_KADR") || currentUser.roles.includes("ROLE_MOD")))itemsArr.push({ label: i18n.t("repeatedWords.organization"), icon: "pi pi-users", command:()=>navigate(`${initialProjectDirectory}/settings/organization`)})
    itemsArr.push({ label: i18n.t("repeatedWords.logOut"), icon: "pi pi-sign-out", command:()=>logOut(navigate)})
    return itemsArr
}